import debounce from 'lodash/debounce';
import { useEffect, useRef, useState } from 'react';
import { logRejectionsToSentry } from '../../Sentry';
import { FAST_USER_INTERACTION_DEBOUNCE } from '../../constants';
import { AlgoliaIndex } from '../../schema/public-algolia/AlgoliaIndex';
import { fetchHits } from '../../schema/public-algolia/fetchHits';
import { useFetch } from '../../services/NetworkService';

export const useAlgoliaAutoComplete = <T,>(index: AlgoliaIndex<T>, input?: string) => {
  const [predictions, setPredictions] = useState<T[]>([]);
  const fetch = useFetch();

  const getPredictions = (input: string) =>
    logRejectionsToSentry('Getting autocomplete predictions', () =>
      fetchHits(fetch, input, index).then(hits => {
        setPredictions(hits);
      }),
    );

  const debouncedGetPredictions = useRef(debounce(getPredictions, FAST_USER_INTERACTION_DEBOUNCE));

  useEffect(() => {
    if (input) {
      debouncedGetPredictions.current(input);
    } else {
      setPredictions([]);
    }
  }, [input, debouncedGetPredictions]);

  return predictions;
};
